import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'
import 'firebase/storage'

var config = {
  apiKey: 'AIzaSyDuWOyz84YJqPx0KvJrEnQ8IQCufWCKT94',
  authDomain: 'bd-kol.firebaseapp.com',
  projectId: 'bd-kol',
  storageBucket: 'bd-kol.appspot.com',
  messagingSenderId: '906303173942',
  appId: '1:906303173942:web:40308a36a7e26b303b6f97',
  measurementId: 'G-HJ506950Y5'
}
firebase.initializeApp(config)
//gsutil cors set cors.json gs://bd-kol.appspot.com

// Get a reference to the database service
export const db = firebase.firestore()
export const auth = firebase.auth()
export const storage = firebase.storage().ref()
export const leadersCol = db.collection('leaders')
export const eventsCol = db.collection('events')
